import StarsIcon from '@/assets/stars-ai.svg?react';
import { useBackgroundTasksStore } from '@/store/background-tasks/background-tasks.store.ts';

import styles from './ActiveTasksIndicator.module.scss';

const ActiveTasksIndicator = () => {
  const hasPending = useBackgroundTasksStore((s) =>
    Object.values(s.tasks).some((t) => t.status === 'pending'),
  );
  if (!hasPending) return null;
  return (
    <p className={styles.indicator} aria-label="Background AI task running">
      <StarsIcon className={styles.icon} />
      <span className={styles.label}>AI</span>
    </p>
  );
};

export default ActiveTasksIndicator;
